export const T = {
  it: {
    kicker: "La porta di accesso alla Capitale dal mare",
    title: "Approda a Roma dal mare",
    lead: "Oltre 840 posti barca da 8 a 60 metri, una promenade di un chilometro con locali, negozi e uffici. Il posto ideale per trascorrere un piacevole soggiorno e godersi la città e il mare di Roma.",
    book: "Prenota il tuo ormeggio",
    stats: [["840", "posti barca"], ["100", "negozi e ristoranti"], ["1400", "posti auto"], ["07–23", "torre di controllo"]],
    aboutK: "Il porto",
    aboutT: "Il Porto Turistico di Roma",
    about: "Inaugurato il 23 giugno 2001, il Porto Turistico di Roma si trova immediatamente a sud della foce del Tevere, a soli 10 minuti di auto dall'aeroporto internazionale di Fiumicino – Leonardo da Vinci e dalle splendide rovine di Ostia Antica. Lungo il porticato, che si estende per quasi un chilometro, ci sono attività dedicate alla nautica, all'abbigliamento, ai servizi e alla ristorazione.",
    more: "Scopri il porto",
    weatherK: "Meteo del porto",
    weatherT: "Vento e mare a Ostia",
    now: "Adesso",
    wind: "Vento",
    wave: "Onde",
    rain: "Pioggia",
    days: ["Oggi", "Domani", "Dopodomani"],
    noWeather: "Previsioni momentaneamente non disponibili",
    newsK: "Dal porto",
    newsT: "Ultime news",
    read: "Leggi",
    allNews: "Tutte le news",
    bookK: "Ormeggio",
    bookT: "Prenota il tuo ormeggio",
    bookText: "Compila il modulo online per richiedere la disponibilità del posto barca: ti risponderemo quanto prima. Per imbarcazioni fino a 20 metri e massimo due notti non serve la prenotazione: basta contattare la torre di controllo sul canale VHF 74, attiva dalle 07.00 alle 23.00, per l'assegnazione del posto barca.",
    bookBtn: "Richiedi disponibilità",
    vhf: "Torre di controllo · VHF canale 74",
    office: "Uffici: 9.00–13.00 e 15.00–19.00",
    preview: "Anteprima della Landing Page · non ancora pubblicata",
  },
  en: {
    kicker: "Rome's gateway from the sea",
    title: "Reach Rome by sea",
    lead: "More than 840 berths from 8 to 60 metres and a one-kilometre promenade with bars, shops and offices. The ideal place for a pleasant stay, enjoying both the city and the sea of Rome.",
    book: "Book your berth",
    stats: [["840", "berths"], ["100", "shops and restaurants"], ["1400", "parking spaces"], ["07–23", "control tower"]],
    aboutK: "The marina",
    aboutT: "Porto Turistico di Roma",
    about: "Opened on 23 June 2001, Porto Turistico di Roma lies just south of the mouth of the Tiber, only 10 minutes by car from Fiumicino – Leonardo da Vinci international airport and the splendid ruins of Ostia Antica. Along the almost one-kilometre arcade you will find businesses dedicated to boating, fashion, services and dining.",
    more: "Discover the marina",
    weatherK: "Marina weather",
    weatherT: "Wind and sea in Ostia",
    now: "Now",
    wind: "Wind",
    wave: "Waves",
    rain: "Rain",
    days: ["Today", "Tomorrow", "Day after"],
    noWeather: "Forecast temporarily unavailable",
    newsK: "From the marina",
    newsT: "Latest news",
    read: "Read",
    allNews: "All news",
    bookK: "Berthing",
    bookT: "Book your berth",
    bookText: "Fill in the online form to request berth availability and we will get back to you as soon as possible. Boats up to 20 metres staying no more than two nights do not need a booking: just call the control tower on VHF channel 74, active from 07:00 to 23:00, to be assigned a berth.",
    bookBtn: "Request availability",
    vhf: "Control tower · VHF channel 74",
    office: "Offices: 9:00–13:00 and 15:00–19:00",
    preview: "Landing Page preview · not published yet",
  },
};
